import React from 'react';

const Label = (props: React.LabelHTMLAttributes<HTMLLabelElement>) => {
  return <label className="text-surfaceTextGraySubtle block" {...props} />;
};

export default Label;
